<template>
    <div :class="classes">
        <div class="layout-3-cols__sidebar layout-3-cols__sidebar--left">
            <slot name="sidebar-left"></slot>
        </div>
        <div class="layout-3-cols__content">
            <slot name="content"></slot>
        </div>
        <div class="layout-3-cols__sidebar layout-3-cols__sidebar--right">
            <slot name="sidebar-right"></slot>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        hasSidebarLeft() {
            return !!this.$slots['sidebar-left'];
        },
        hasSidebarRight() {
            return !!this.$slots['sidebar-right'];
        },
        hasNoSidebars() {
            return !this.hasSidebarLeft && !this.hasSidebarRight;
        },
        classes() {
            return {
                'layout-3-cols': true,
                'layout-3-cols--has-no-sidebar-left': !this.hasSidebarLeft,
                'layout-3-cols--has-sidebar-right': this.hasSidebarRight,
                'layout-3-cols--has-no-sidebars': this.hasNoSidebars,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
.layout-3-cols {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: var(--spacing-4);
    max-width: 1328px;
    margin: 0 auto;

    &--has-sidebar-right {
        grid-template-rows: max-content 1fr;
    }

    &--has-no-sidebar-left {
        @media only screen and (max-width: 1279px) {
            .layout-3-cols {
                &__sidebar--left {
                    display: none;
                }

                &__sidebar--right {
                    grid-column: span 12;
                    margin: 0 auto;
                    max-width: 652px;
                    width: 100%;
                }

                &__content {
                    grid-column: span 12;
                    margin: 0 auto;
                    max-width: 652px;
                }
            }
        }
    }

    &__sidebar {
        grid-column: span 3;

        @media only screen and (max-width: 1279px) {
            &--left {
                grid-row: 1 / span 2;
                width: 272px;
            }

            &--right {
                grid-column: span 9;
                margin: 0 auto;
                max-width: 652px;
                width: 100%;
            }
        }
    }

    &__content {
        grid-column: span 6;

        @media only screen and (max-width: 1279px) {
            grid-column: span 9;
            margin: 0 auto;
            max-width: 652px;
        }
    }

    @media only screen and (max-width: 1279px) {
        &--has-no-sidebars {
            display: block;

            .layout-3-cols__sidebar {
                display: none;
            }
        }
    }
}
</style>
